/*
 * Decléor — Animated efficacy stats
 * ---------------------------------------------------------------------------
 * Rolls each <number-flow data-stat="N"> from 0 → N EVERY time it scrolls into
 * view (snaps back to 0 when it leaves, so the count-up replays on each entry).
 * Uses the self-hosted NumberFlow lib (assets/number-flow.js), loaded lazily on
 * first appearance. Respects prefers-reduced-motion. No-op without its hooks.
 */
(function () {
  'use strict';

  var script = document.querySelector('script[data-stat-counter]');
  if (!script) return;
  var nfSrc = script.getAttribute('data-numberflow-src');
  var nums = document.querySelectorAll('number-flow[data-stat]');
  if (!nums.length || !nfSrc || !('customElements' in window) || !('IntersectionObserver' in window)) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var loading = null;
  function loadLib() {
    if (loading) return loading;
    loading = new Promise(function (resolve) {
      if (customElements.get('number-flow')) { resolve(); return; }
      var m = document.createElement('script');
      m.type = 'module';
      m.src = nfSrc;
      m.addEventListener('load', function () { customElements.whenDefined('number-flow').then(resolve, resolve); });
      m.addEventListener('error', resolve);
      document.head.appendChild(m);
    });
    return loading;
  }

  function target(el) { var v = parseFloat(el.getAttribute('data-stat')); return isNaN(v) ? 0 : v; }

  function animate(el) {
    if (typeof el.update !== 'function') return;        // lib failed → keep the fallback text
    var v = target(el);
    if (reduce) { el.animated = false; el.update(v); return; }
    el.animated = false; el.update(0);                  // snap to 0 (no count-down)
    requestAnimationFrame(function () {                 // then roll 0 → v
      el.animated = true;
      el.update(v);
    });
  }

  function rewind(el) {                                 // off-screen → reset, ready to replay
    if (typeof el.update !== 'function') return;
    el.animated = false;
    el.update(0);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      if (e.isIntersecting) {
        loadLib().then(function () { animate(el); });
      } else if (!reduce) {
        rewind(el);
      }
    });
  }, { threshold: 0.4 });

  nums.forEach(function (n) { io.observe(n); });
})();
